export default __webpack_public_path__ + "static/media/step2aDarkMode.8f56f30c.svg";